/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/Redux/TestPlansSegmentActions" />
import { Favorite } from "Favorites/Common/Contracts/Favorite";
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const TestPlansSegmentActions = {

    /**
     * getInitialFavoriteStatusForPlan: dispatched to find whether current plan is favorited or not
     */
    getInitialFavoriteStatusForPlan: (planId: number) => createAction(TestPlansSegmentActionsTypes.getInitialFavoriteStatusForPlan, { planId }),

    /**
     * updateFavoriteStatus: dispatched to update the favorite state of current plan
     */
    updateFavoriteStatus: (favoriteStatus: boolean, favoriteId?: string) =>
        createAction(TestPlansSegmentActionsTypes.updateFavoriteStatus, { favoriteStatus, favoriteId }),

    /**
     * onToggleFavorite: dispatched when the favorite star button is clicked to toggle favorite status
     */
    onToggleFavorite: (testPlanId: number, testPlanName: string, favoriteStatus: boolean, favoriteId: string) =>
        createAction(TestPlansSegmentActionsTypes.onToggleFavorite, { testPlanId, testPlanName, favoriteStatus, favoriteId }),

    /**
     * fetchFavorites: dispatched to fetch all the test plans which are favorites for a project
     */
    fetchFavorites: () => createAction(TestPlansSegmentActionsTypes.fetchFavorites),

    /**
     * updateFavoritePlansList: dispatched to update the list of favorite plans for the project
     */
    updateFavoritePlansList: (favorites: Favorite[]) => createAction(TestPlansSegmentActionsTypes.updateFavoritePlansList, { favorites }),

    /**
     * changeTestPlan: dispatched to fetch data when user changes Test Plan
     */
    changeTestPlan: (planId: number) => createAction(TestPlansSegmentActionsTypes.changeTestPlan, { planId }),

    /**
     * editTestPlan: dispatched when edit test plan is clicked in the test plans context menu
     */
    editTestPlan: (planId: number) => createAction(TestPlansSegmentActionsTypes.editTestPlan, { planId }),

    /**
     * getTestPlanProgressSummary: dispatched to get test plan progress summary.
     */
    getTestPlanProgressSummary: (planId: number) => createAction(TestPlansSegmentActionsTypes.getTestPlanProgressSummary, { planId }),

    /**
     * updateTestPlanProgressSummary: dispatched to update the test plan progress summary.
     */
    updateTestPlanProgressSummary: (testPlanProgressSummary: string) =>
        createAction(TestPlansSegmentActionsTypes.updateTestPlanProgressSummary, { testPlanProgressSummary }),

    /**
     * openProgressReport: dispatched to open progress report when clicked on view report.
     */
    openProgressReport: (planId: number) => createAction(TestPlansSegmentActionsTypes.openProgressReport, { planId }),

    /**
     * openTestPlanSettingsDialog: dispatched to open test plans settings dialog
     */
    openTestPlanSettingsDialog: (planId: number) => createAction(TestPlansSegmentActionsTypes.openTestPlanSettingsDialog, { planId })
};

export const enum TestPlansSegmentActionsTypes {
    getInitialFavoriteStatusForPlan = "TestPlansSegment/getInitialFavoriteStatusForPlan",
    updateFavoriteStatus = "TestPlansSegment/updateFavoriteStatus",
    onToggleFavorite = "TestPlansSegment/onToggleFavorite",
    fetchFavorites = "TestPlansSegment/fetchFavorites",
    updateFavoritePlansList = "TestPlansSegment/updateFavoritePlansList",
    changeTestPlan = "TestPlansSegment/changeTestPlan",
    editTestPlan = "TestPlansSegment/editTestPlan",
    getTestPlanProgressSummary = "TestPlansSegment/getTestPlanProgressSummary",
    updateTestPlanProgressSummary = "TestPlansSegment/updateTestPlanProgressSummary",
    openProgressReport = "TestPlansSegment/openProgressReport",
    openTestPlanSettingsDialog = "TestPlansSegment/openTestPlanSettingsDialog"
}

export type TestPlansSegmentActions = ActionsUnion<typeof TestPlansSegmentActions>;
